'use strict';

// The $route() helper ensures that routes are reactive to changes 
// to window.Ziggy after Alpine has initially rendered.

export const AlpineRoute = (route) => (Alpine) => {
	const routes = [];
	
	Alpine.magic('route', function(el, { Alpine }) {
		const config = {
			regenerate: () => null,
			value: Alpine.reactive({ href: '#' }),
		};
		
		routes.push(config);
		
		return (name, params = [], absolute = true) => {
			config.regenerate = () => config.value.href = route(name, params, absolute);
			config.regenerate();
			
			return config.value.href;
		};
	});
	
	window.addEventListener('ziggy', function(event) {
		routes.forEach((config) => config.regenerate());
	});
};
